import React, { useState, useEffect } from 'react';
import {
  Nav,
  NavContainer,
  NavLogo,
  NavItems,
  NavLink,
  ButtonContainer,
  GithubButton,
  MobileIcon,
  MobileMenu,
  MobileMenuLink,
} from './NavbarStyledComponent';
import { FaBars, FaTimes, FaGithub } from 'react-icons/fa';
import { Bio } from '../../data/constants';
import { AnimatePresence, motion } from 'framer-motion';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState('home');

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Education', href: '#education' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Contact', href: '#contact' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);

      const sectionIds = ['home', 'work-experience', 'experience', 'education', 'projects', 'contact'];
      const scrollPosition = window.scrollY + 120;

      for (let i = sectionIds.length - 1; i >= 0; i--) {
        const sectionId = sectionIds[i];
        const element = document.getElementById(sectionId);
        if (element) {
          const top = element.offsetTop;
          if (scrollPosition >= top) {
            if (sectionId === 'work-experience' || sectionId === 'experience') {
              setActiveSection('experience');
            } else if (sectionId === 'about' || sectionId === 'home') {
              setActiveSection('home');
            } else {
              setActiveSection(sectionId);
            }
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleScrollTo = (e, href) => {
    e.preventDefault();
    setIsOpen(false);
    const targetId = href.replace('#', '');
    const element = document.getElementById(targetId);
    if (element) {
      const navOffset = 80;
      const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - navOffset;

      window.scrollTo({
        top: Math.max(0, offsetPosition),
        behavior: 'smooth',
      });
    } else if (href === '#home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <Nav $scrolled={scrolled}>
      <NavContainer>
        <NavLogo href="#home" onClick={(e) => handleScrollTo(e, '#home')}>
          Ronit<span>.dev</span>
        </NavLogo>

        <MobileIcon onClick={() => setIsOpen(!isOpen)} aria-label="Toggle Navigation">
          {isOpen ? <FaTimes /> : <FaBars />}
        </MobileIcon>

        <NavItems>
          {navLinks.map((link) => {
            const linkId = link.href.replace('#', '');
            const isActive = activeSection === linkId;
            return (
              <li key={link.name}>
                <NavLink
                  href={link.href}
                  $isActive={isActive}
                  onClick={(e) => handleScrollTo(e, link.href)}
                >
                  {link.name}
                </NavLink>
              </li>
            );
          })}
        </NavItems>

        <ButtonContainer>
          <GithubButton href={Bio.github} target="_blank" rel="noopener noreferrer">
            <FaGithub size={16} />
            GitHub
          </GithubButton>
        </ButtonContainer>
      </NavContainer>

      <AnimatePresence>
        {isOpen && (
          <MobileMenu
            as={motion.div}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.25 }}
          >
            {navLinks.map((link) => {
              const linkId = link.href.replace('#', '');
              const isActive = activeSection === linkId;
              return (
                <MobileMenuLink
                  key={link.name}
                  href={link.href}
                  $isActive={isActive}
                  onClick={(e) => handleScrollTo(e, link.href)}
                >
                  {link.name}
                </MobileMenuLink>
              );
            })}
            <GithubButton
              href={Bio.github}
              target="_blank"
              rel="noopener noreferrer"
              style={{ marginTop: '8px', width: '80%', maxWidth: '280px' }}
            >
              <FaGithub size={16} />
              GitHub Profile
            </GithubButton>
          </MobileMenu>
        )}
      </AnimatePresence>
    </Nav>
  );
};

export default Navbar;
